import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NavigationContext } from '../../context/NavigationContext';

const StyledI = styled.i`
    aspect-ratio: 1;
    background: ${props => props.styles?.color};
    display: block;
    mask: url(${props => encodeURI(props.styles?.mask)}) center center no-repeat;
    -webkit-mask: url(${props => props.styles?.mask}) center center no-repeat;
    mask-size: contain;
    -webkit-mask-size: contain;
`;

export const IconComponent = ({ iconName, ...props }) => {
    const { iconData } = useContext(NavigationContext);
    const { rootUrl, assetVersion } = iconData || {};

    const styles = {
        ...(props.styles || {}),
        mask: `${rootUrl}/${iconName}.svg?assetVersion=${assetVersion}`,
    };

    return <StyledI {...props} styles={styles} />;
};

IconComponent.propTypes = {
    iconName: PropTypes.string.isRequired,
    styles: PropTypes.object,
};
